import { render, staticRenderFns } from "./UpgradeConfirmation.vue?vue&type=template&id=edc4835e&"
import script from "./UpgradeConfirmation.vue?vue&type=script&lang=js&"
export * from "./UpgradeConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports